import { useEffect } from "react";
import Select from "react-select";
import type { MetaDataPropertyType } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchOperator } from "types/qbank/searchOperator";

export default function Dropdown(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setValue: (value: string) => void;
  value: string;
  isMulti?: boolean;
}) {
  useEffect(() => {
      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.CONTAINS_ANY,
        value: Array.isArray(props.value) ? props.value : typeof props.value === 'string' && props.value.length > 0
          ? props.value.split(",").map((val) => val.trim())
          : undefined,
        label: props.propertyType.name,
      });
    // eslint-disable-next-line
  }, [props.value]);

  return (
    <div className="field" data-testid="dropdown">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <Select
          value={
            Array.isArray(props.value)
              ? props.value.map((value) => {
                return { value: value, label: value };
              })
              : typeof props.value === 'string' && props.value.length > 0
                ? props.value.split(",").map((value) => {
                  return { value: value, label: value };
                })
                : []
          }
          isMulti={!!props.isMulti}
          // @ts-ignore can't figure out the "correct"-correct typing here
          onChange={(value: [{ value: string; label: string }]) => {
            if (!Array.isArray(value)) {
              value = [value];
            }
            props.setValue(value.map((val) => val.value).join(","));
          }}
          options={props.propertyType.definition.options?.map((value) => {
            return { value: value, label: value };
          })}
        />
      </div>
    </div>
  );
}
